import type { LogContext, Logger } from './logger';
import { sanitize } from './sanitize';

function format(level: string, message: string, context?: LogContext, error?: unknown): unknown[] {
  const parts: unknown[] = [`[${level}]`, message];
  if (context && Object.keys(context).length > 0) parts.push(sanitize(context));
  if (error !== undefined) parts.push(error);
  return parts;
}

function build(parentContext: LogContext): Logger {
  const merge = (ctx?: LogContext): LogContext | undefined => {
    if (!ctx && Object.keys(parentContext).length === 0) return undefined;
    return { ...parentContext, ...(ctx ?? {}) };
  };
  return {
    debug: (message, context) => console.debug(...format('debug', message, merge(context))),
    info: (message, context) => console.info(...format('info', message, merge(context))),
    warn: (message, context, error) => console.warn(...format('warn', message, merge(context), error)),
    error: (message, context, error) => console.error(...format('error', message, merge(context), error)),
    withContext: (context) => build({ ...parentContext, ...context }),
  };
}

export function createConsoleLogger(): Logger {
  return build({});
}
